import React from "react";

import styles from "../../../../styles/address-preferences.module.scss";

import { Drawer } from "../../../components/Drawer";
import { Button } from "../../../components/Button";
import { Checkbox } from "../../../components/Checkbox";
import { Select } from "../../../components/Select";

import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";

const AddressSearchType = {
  ZIPCODE: {
    id: "ZIPCODE",
    name: "CEP",
  },
  FULL_TEXT_SEARCH: {
    id: "FULL_TEXT_SEARCH",
    name: "Texto",
  },
  GEOLOCATION: {
    id: "GEOLOCATION",
    name: "Geolocalização",
  },
};

export default class AddressPreferencesDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchMethods: [
        AddressSearchType.ZIPCODE.id,
        AddressSearchType.FULL_TEXT_SEARCH.id,
      ],
      priority: AddressSearchType.ZIPCODE.id,
      loading: false,
    };
  }

  async componentDidMount() {
    const environmentId = EnvironmentStorage.getSelectedEnvironment();
    const addressPreferences = await EnvironmentsAPI.getConfigurationsByAlias(
      environmentId,
      "address_preferences",
      []
    );

    this.setState({
      searchMethods: addressPreferences?.searchMethods || [
        AddressSearchType.ZIPCODE.id,
        AddressSearchType.FULL_TEXT_SEARCH.id,
      ],
      priority: addressPreferences?.priority || AddressSearchType.ZIPCODE.id,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { searchMethods } = this.state;

    if (
      prevState.searchMethods !== searchMethods &&
      searchMethods.length === 1
    ) {
      this.setState({
        priority: searchMethods[0],
      });
    }
  }

  updateSearchMethod(type) {
    const { searchMethods } = this.state;

    if (searchMethods.includes(type)) {
      const newTypes = searchMethods.filter(
        (searchType) => searchType !== type
      );
      this.setState({
        searchMethods: newTypes,
      });
    } else {
      this.setState({
        searchMethods: [...searchMethods, type],
      });
    }
  }

  async save() {
    const { searchMethods, priority } = this.state;

    this.setState({ loading: true });

    const environmentId = EnvironmentStorage.getSelectedEnvironment();

    const updateResponse = await EnvironmentsAPI.putConfigurationsByAlias(
      environmentId,
      "address_preferences",
      {
        address_preferences: {
          searchMethods,
          priority,
        },
      }
    );

    if (updateResponse.getErrors([]).length > 0) {
      alert({
        text: updateResponse.getErrors()[0],
        buttonText: "Ok",
      });
      this.setState({ loading: false });
      return false;
    }

    alert({
      text: "Configurações alteradas sucesso",
      buttonText: "Ok",
    });

    this.setState({ loading: false });
    return true;
  }

  render() {
    const { visible, onClose } = this.props;
    const { searchMethods, priority, loading } = this.state;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title="Registro de endereços"
      >
        <Checkbox
          name="preference-zipcode"
          design="two"
          className="mb-10"
          checked={searchMethods.includes(AddressSearchType.ZIPCODE.id)}
          onChange={() => this.updateSearchMethod(AddressSearchType.ZIPCODE.id)}
        >
          Permitir busca por CEP
        </Checkbox>

        <Checkbox
          name="preference-text"
          design="two"
          className="mb-10"
          checked={searchMethods.includes(
            AddressSearchType.FULL_TEXT_SEARCH.id
          )}
          onChange={() =>
            this.updateSearchMethod(AddressSearchType.FULL_TEXT_SEARCH.id)
          }
        >
          Permitir busca por texto
        </Checkbox>

        {searchMethods.length > 1 && (
          <Select
            design="two"
            label="Priorizar busca por"
            onChange={(e) => this.setState({ priority: e.target.value })}
            className="mt-10"
            value={priority}
            options={Object.values(AddressSearchType).map(({ id, name }) => ({
              label: name,
              value: id,
              selected: priority === id,
            }))}
          />
        )}

        <div className={styles.footer}>
          <Button
            className="w-100"
            design="primary"
            disabled={loading || searchMethods.length === 0}
            loading={loading}
            onClick={() => this.save()}
          >
            Salvar
          </Button>
        </div>
      </Drawer>
    );
  }
}
